
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { HR } from "@/lib/model/group/group";

@Component({ components: {} })
export default class AiGroup extends Vue {
  passwd = "";
  judgeOutId = "";

  //设备查询
  isMobile(): boolean {
    const isIos = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
    const isAndroid = /(Android)/i.test(navigator.userAgent);
    return isIos || isAndroid;
  }

  created() {
    if (this.isMobile()) return;

    const params = this.$route.query;
    if (params.judgeOutId) {
      this.judgeOutId = String(params.judgeOutId);
    } else {
      this.$message.error("链接不正确，请核对后再试");
    }
  }
  toLogin() {
    if (!this.passwd) {
      this.$message.warning("请输入密码");
      return;
    }
    HR.login({ judgeOutId: this.judgeOutId, passwd: this.passwd }).then(res => {
      if (res) {
        const previewUrl = `/exam/mark?judgeOutId=${this.judgeOutId}&passwd=${this.passwd}`;
        this.$router.push(previewUrl);
      } else {
        this.$message.error("密码错误");
      }
    });
  }
}
